import React, { useEffect } from 'react'
import { Box } from '@mui/material'

import { AppLinksBlock, AppRunProgress } from '@components'
import { REPORT_STATUS } from '@constants'
import { useReportsHomeData } from 'Pages/Main/Home/@hooks'
import { homeRunningExecutions, homeRunningStatus } from 'Pages/Main/Home/@signals'
import { reportSearchesModalId } from '@signals'


// The row does not poll: it registers its execution in homeRunningExecutions and reads its
// status from homeRunningStatus, filled by the single status-multiple poll of the table.
export default function ReportHomeListTableRunningBlock({ rowData }) {
	const idReport = rowData.idReport
	const idExecution = rowData.idLastExecution
	const isRunning = rowData.statusLastExecution === REPORT_STATUS.RUNNING

	const { setReportData } = useReportsHomeData()

	useEffect(() => {
		if (!isRunning || !idExecution) return
		if (!homeRunningExecutions.value.includes(idExecution)) {
			homeRunningExecutions.value = [ ...homeRunningExecutions.value, idExecution ]
		}
		return () => {
			homeRunningExecutions.value = homeRunningExecutions.value.filter(id => id !== idExecution)
		}
	}, [ idExecution, isRunning ])

	const status = homeRunningStatus.value[idExecution] || {}
	const completed = !!status.ExecutionGlobalStatusCompleted
	const isGenerating = !!status.generating
	const showAnalyzers = !!(status.ready || completed)

	useEffect(() => {
		if (completed) setReportData({ idReport: idReport, statusLastExecution: REPORT_STATUS.READY })
	}, [ completed ])

	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 1 }}>
		<AppRunProgress
			label={!isGenerating && 'Running'}
			actual={status.percentage || 0}
			total={100}
			done={status.completeTasksString || 0}
			totalText={status.totalTasksString || 0}
			generating={isGenerating}
			onClick={() => {
				if (!isGenerating) {
					reportSearchesModalId.value = idExecution
				}
			}}
		/>
		{showAnalyzers && <Box sx={{ mt: 1 }}>
			<AppLinksBlock
				reportExecutionID={status.idReportExecution || idExecution}
				downMultiReport={!!status.executionHasGenerations}
				downMultiExport={!!status.executionHasExports}
				hasCompetitionSites={rowData.hasCompetitionSites}
				hasDirectSites={rowData.hasDirectSites}
			/>
		</Box>}
	</Box>
}
